"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoyaltyDialog = void 0;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var ShowLoyaltyDialog = _interopRequireWildcard(require("@ori-events/show-loyalty-dialog"));
var _react = require("react");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const useLoyaltyDialog = () => {
  const [data, setData] = (0, _react.useState)();
  const handleLoyaltyDialogResult = (0, _react.useCallback)(result => {
    if (data) {
      const event = new CustomEvent(LoyaltyDialogResult.Name, {
        detail: {
          ...data,
          result
        }
      });
      window.dispatchEvent(event);
      // unmountDialog
      setData(undefined);
    }
  }, [data]);
  const handleClose = (0, _react.useCallback)(() => handleLoyaltyDialogResult(LoyaltyDialogResult.LoyaltyDialogResults.CLOSE), [handleLoyaltyDialogResult]);
  const handleBuyForPoints = (0, _react.useCallback)(() => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_POINTS), [handleLoyaltyDialogResult]);
  const handleBuyForMoney = (0, _react.useCallback)(() => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_MONEY), [handleLoyaltyDialogResult]);
  (0, _react.useEffect)(() => {
    const showLoyaltyDialogCallback = event => {
      setData(event.detail);
    };
    window.addEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);
    return () => window.removeEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);
  }, []);
  return {
    data,
    handleBuyForMoney,
    handleBuyForPoints,
    handleClose
  };
};
exports.useLoyaltyDialog = useLoyaltyDialog;